import React from 'react'
import ReactDOM from 'react-dom/client'
import ReactGA from 'react-ga4'
import 'index.css'

// Routing
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import * as route from 'constants/routes'

// Pages
import * as PAGE from 'pages'

import Footer from 'components/layout/Footer'

const App = () => {
    ReactGA.initialize('G-K4DJ4H0XJY')
    ReactGA.send({ hitType: 'pageview', page: '/', title: 'Grays Run' })

    return (
        <section className="page-fill-background">
            <Router>
                <Routes>
                    <Route path={route.INDEX} element={<PAGE.Home />} />
                    <Route path={route.run_2025} element={<PAGE.Run2025 />} />
                    <Route path={route.run_2026} element={<PAGE.Run2026 />} />
                    <Route path="*" element={<PAGE.PageNotFound />} />
                </Routes>
                <Footer />
            </Router>
        </section>
    )
}

const AppContainer = () => {
    return <App />
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<AppContainer />)
